import React from "react";
import { Badge, ListItem, ListItemText, makeStyles, Theme } from "@material-ui/core";
import NavLinkWrapper from "./NavLinkWrapper";

interface StyleProps {
    activeClassName: string;
}

interface PlatformSidebarLinkProps {
    name: string;
    to: string;
    badge?: number | null;
    icon?: React.ComponentType<{ className?: string }>;
}

const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
    container: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(3),
        fontWeight: theme.typography.fontWeightRegular as number,
        alignItems: "center" as const,
        "&:hover": {
            background: "#F4EEFF" as const,
            borderRadius: "8px" as const,
        },
        "&.active": {
            background: "#F4EEFF" as const,
            borderRadius: "8px" as const,
        },
    },
    label: {
        margin: 0,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    labelText: {
        color: "#48464A" as const,
        fontWeight: 500 as const,
        ".active &": {
            color: "#483795" as const,
            fontWeight: 600 as const,
        }
    },
    badge: {
        marginLeft: "auto" as const,
    },
    icon: {
        color: "#48464A" as const,
    },
}));

const PlatformSidebarLink: React.FC<PlatformSidebarLinkProps> = ({ name, to, badge = null, icon: Icon }) => {
    const activeClassName = "active";
    const classes = useStyles({ activeClassName });

    return (
        <ListItem
            button
            dense
            component={NavLinkWrapper}
            exact
            to={to}
            activeClassName={activeClassName}
            className={classes.container}
        >
            {Icon && <Icon className={classes.icon} />}
            <ListItemText className={classes.label} classes={{ primary: classes.labelText }}>{name}</ListItemText>
            {badge && (
                <Badge className={classes.badge} color="error" badgeContent={badge} />
            )}
        </ListItem>
    );
};

export default PlatformSidebarLink;
